// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"74e36667","320":"2663b470","351":"89bf7a28","402":"1b663f9c","481":"706a7540","504":"557aa730","573":"ec4b5210","575":"c75614e4","727":"7c3be836","742":"bee03a57","824":"18f7eb92","862":"95f84c73"}[chunkId] + ".chunk.js";
};